// Static configuration lists used by the Release 1 UI shell only.
// These are NOT operational/sample data — they are fixed reference lists
// (role definitions, the permission catalogue and available integrations).
// All operational dashboard/content data comes live from Supabase via /api.

export const DEFAULT_ROLES = [
  { name: "Owner", desc: "High-level visibility and strategic approvals.", system: true, members: 1 },
  { name: "Super Admin", desc: "Complete application control.", system: true, members: 1 },
  { name: "Admin", desc: "Administrative access based on assigned permissions.", system: true, members: 0 },
  { name: "Content Manager", desc: "Planning, assignment, workflow and calendar.", system: true, members: 0 },
  { name: "Content Writer", desc: "Blogs, scripts, captions and research.", system: true, members: 1 },
  { name: "SEO Analyst", desc: "Keywords, search intent, optimisation.", system: true, members: 0 },
  { name: "Social Media Manager", desc: "Instagram workflow and social planning.", system: true, members: 1 },
  { name: "YouTube Manager", desc: "YouTube planning, production, publishing.", system: true, members: 0 },
  { name: "Authenticity Reviewer", desc: "Primary role for Vishwa.", system: true, members: 1 },
  { name: "Lead Reviewer", desc: "Primary role for Vijayalakshmi.", system: true, members: 1 },
  { name: "Designer", desc: "Carousels, covers and visual assets.", system: true, members: 0 },
  { name: "Video Editor", desc: "Reels, Shorts and YouTube production.", system: true, members: 1 },
  { name: "Publisher", desc: "Scheduling and publishing.", system: true, members: 0 },
  { name: "Analyst", desc: "Performance and content insights.", system: true, members: 0 },
  { name: "Viewer", desc: "Read-only access.", system: true, members: 0 },
];

export const PERMISSIONS = [
  "View", "Create", "Edit", "Assign", "Comment", "Upload", "Submit", "Review", "Approve",
  "Return for Changes", "Publish", "Schedule", "Delete", "Archive", "Export", "View Analytics",
  "Manage Users", "Manage Roles", "Manage Workflows", "Manage AI", "Manage Integrations",
  "Manage Settings", "View Activity History",
];

export const INTEGRATIONS = [
  { key: "supabase", name: "Supabase", desc: "Database, authentication and storage.", status: "Not Connected", primary: true },
  { key: "openai", name: "OpenAI API", desc: "AI reviews, style and clarity analysis.", status: "Not Connected" },
  { key: "gsc", name: "Google Search Console", desc: "Search analytics for blogs.", status: "Not Connected" },
  { key: "ga4", name: "Google Analytics 4", desc: "Website traffic analytics.", status: "Not Connected" },
  { key: "youtube", name: "YouTube", desc: "Video publishing and analytics.", status: "Not Connected" },
  { key: "meta", name: "Instagram / Meta", desc: "Reel and post analytics.", status: "Not Connected" },
  { key: "pabbly", name: "Pabbly", desc: "Automation & WhatsApp delivery bridge.", status: "Not Connected" },
  { key: "email", name: "Transactional Email", desc: "Nirvana-owned email sender.", status: "Not Connected" },
  { key: "plagiarism", name: "Plagiarism Service", desc: "External originality checks.", status: "Not Connected" },
];
